import React from 'react';
import { BookOpenIcon, LayersIcon, UsersIcon, GraduationCapIcon, CheckIcon } from 'lucide-react';
const stats = [[BookOpenIcon, '360', 'Pages of curriculum'], [LayersIcon, '6', 'Strategic volumes'], [UsersIcon, 'All', 'Teaching formats'], [GraduationCapIcon, 'A1–C1', 'Full coverage']] as const;
const tags = [['Visual Vocabulary', 'For faster memorization'], ['Real-world Dialogues', 'To trigger immediate conversation'], ['Grammar Mastery', 'Explained simply and practically'], ['Reading & Comprehension', 'With authentic cultural hooks'], ['Creative Projects', 'To make Italian come alive'], ['Progress Assessments', 'To track student growth'], ['Conversation Starters', 'To eliminate awkward silences'], ['Session Warm-ups', 'To start every lesson with energy']];
export function SystemSection() {
  return <section className="border-y-4 border-[#d4af37] bg-[#16161F] px-5 py-20" data-id="element-206" data-mp="2iwbwo4k83695">
      <div className="mx-auto max-w-6xl text-center" data-id="element-207" data-mp="2dvo7lofk0zhk">
        <p className="inline-block bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#0A0A0A]" data-id="element-208" data-mp="13yoflsqtnybw">
          The complete system to stop improvising lessons
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-209" data-mp="u1abmsm3520h">
          Italiano <span className="text-[#d4af37]" data-id="element-210" data-mp="yzlhytd68udy">Ready™</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-[#B0B0C0]" data-id="element-211" data-mp="yxsfzrdi6yca">
          360 pages of structured Italian curriculum. Visual vocabulary,
          real-world dialogues, logical grammar progressions, and deep cultural
          immersion.{' '}
          <strong className="text-white" data-id="element-212" data-mp="1cr9swtbopctc">
            Everything ready for your next student.
          </strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-213" data-mp="1ccuwtxivd9u">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-[#d4af37]/25 bg-[#0A0A0A] p-6" data-id="element-214" data-mp="6bz8j4h9ivj6">
              <Icon className="mx-auto h-7 w-7 text-[#d4af37]" data-id="element-215" data-mp="28wthttq702z6" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-216" data-mp="23yi6fek91keu">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-217" data-mp="1z79w8gb3hv0m">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-[#d4af37]/25 bg-[#0A0A0A] p-7" data-id="element-218" data-mp="1p9vulmttzasd">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-219" data-mp="1p7sta6n89v8c">
            Full coverage, every category
          </p>
          <div className="mt-5 grid gap-2 text-left sm:grid-cols-2" data-id="element-220" data-mp="1g8nur0bo21w6">
            {tags.map(([tag, note]) => <div key={tag} className="flex items-start gap-2 border border-[#d4af37]/25 bg-[#16161F] px-3 py-3" data-id="element-221" data-mp="1bbe7nrbr22bi">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d4af37]" data-id="element-222" data-mp="35on9cwy20jj7" />
                <p className="text-xs font-bold text-white" data-id="element-223" data-mp="35mklaiggp0h4">
                  {tag}
                  <span className="ml-1 font-medium text-[#B0B0C0]" data-id="element-224" data-mp="3d7mup852sl57">
                    — {note}
                  </span>
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}